// extracted by mini-css-extract-plugin
export var menu = "Menu-module--menu--3SbXJ";
export var menu__list = "Menu-module--menu__list--WI1fI";
export var menu__listItem = "Menu-module--menu__list-item--3jbkZ";
export var menu__listItemLink = "Menu-module--menu__list-item-link--m53eI";
export var menu__listItemLinkActive = "Menu-module--menu__list-item-link--active--3zwRe";